import { MainMenuItem } from '@/types/common';
import { ROUTES } from './routes';
import { BankApplicationAggregateInfo } from '@/types/bankApplications';

// Function to create bank application menu with counts
export const createBankApplicationMenu = (
  aggregateInfo?: BankApplicationAggregateInfo,
): MainMenuItem | null => {
  if (!aggregateInfo) {
    return null;
  }

  return {
    key: 'bank-account-applications',
    label: 'Bank Account Applications',
    route: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
    activeRoutes: [
      ROUTES.BANK_ACCOUNT_APPLICATIONS,
      ROUTES.BANK_ACCOUNT_APPLICATION_DETAILS,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED,
    ],
    subpages: [
      {
        key: 'draft',
        label: `Draft (${aggregateInfo.totalDraft})`,
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT],
      },
      {
        key: 'awaiting-esign',
        label: `Awaiting E-Sign (${aggregateInfo.totalAwaitingESign})`,
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN],
      },
      {
        key: 'submitted',
        label: `Submitted (${aggregateInfo.totalSubmitted})`,
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED],
      },
      {
        key: 'external-account-review',
        label: `External Account Review. (${aggregateInfo.totalExternalAccountReview})`,
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_EXTERNAL_ACCOUNT_REVIEW,
        activeRoutes: [
          ROUTES.BANK_ACCOUNT_APPLICATIONS_EXTERNAL_ACCOUNT_REVIEW,
        ],
      },
      {
        key: 'under-review',
        label: `Under Review (${aggregateInfo.totalUnderReview})`,
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW],
      },
      {
        key: 'completed',
        label: `Completed (${aggregateInfo.totalCompleted})`,
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED],
      },
    ],
  };
};

export const STAFF_MENU: MainMenuItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    route: ROUTES.HOMEPAGE,
    activeRoutes: [ROUTES.HOMEPAGE],
  },
  {
    key: 'staff',
    label: 'Staff',
    route: ROUTES.STAFF,
    activeRoutes: [ROUTES.STAFF],
  },
  {
    key: 'companies',
    label: 'Companies',
    route: ROUTES.COMPANIES,
    activeRoutes: [ROUTES.COMPANIES],
  },
  {
    key: 'customers',
    label: 'Customers',
    route: ROUTES.CUSTOMERS,
    activeRoutes: [ROUTES.CUSTOMERS],
  },
  {
    key: 'businesses',
    label: 'Businesses',
    route: ROUTES.BUSINESSES,
    activeRoutes: [ROUTES.BUSINESSES],
  },
  {
    key: 'teammates',
    label: 'Teammates',
    route: ROUTES.TEAMMATES,
    activeRoutes: [ROUTES.TEAMMATES],
  },
  {
    key: 'bank-accounts',
    label: 'Bank Accounts',
    route: ROUTES.BANK_ACCOUNTS,
    activeRoutes: [ROUTES.BANK_ACCOUNTS],
  },
  {
    key: 'bank-account-applications',
    label: 'Bank Account Applications',
    route: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
    activeRoutes: [
      ROUTES.BANK_ACCOUNT_APPLICATIONS,
      ROUTES.BANK_ACCOUNT_APPLICATION_DETAILS,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED,
    ],
    subpages: [
      {
        key: 'draft',
        label: 'Draft',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT],
      },
      {
        key: 'awaiting-esign',
        label: 'Awaiting E-Sign',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN],
      },
      {
        key: 'submitted',
        label: 'Submitted',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED],
      },
      {
        key: 'under-review',
        label: 'Under Review',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW],
      },
      {
        key: 'completed',
        label: 'Completed',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED],
      },
    ],
  },
  {
    key: 'external-accounts',
    label: 'External Accounts',
    route: ROUTES.EXTERNAL_ACCOUNTS,
    activeRoutes: [ROUTES.EXTERNAL_ACCOUNTS],
  },
  {
    key: 'transaction-review',
    label: 'Transaction Review',
    route: ROUTES.TRANSACTION_REVIEW,
    activeRoutes: [ROUTES.TRANSACTION_REVIEW],
  },
  {
    key: 'program-settings',
    label: 'Program Settings',
    route: ROUTES.PROGRAM_SETTINGS_GENERAL,
    activeRoutes: [
      ROUTES.PROGRAM_SETTINGS_GENERAL,
      ROUTES.PROGRAM_SETTINGS_DOCUMENT_LINKS,
      ROUTES.BRANDING_THEMES,
      ROUTES.BRANDING_THEME_ADD,
      ROUTES.BRANDING_THEME_EDIT_PARAMS,
      ROUTES.BRANDING_THEME_VIEW_PARAMS,
    ],
    subpages: [
      {
        key: 'general',
        label: 'General',
        route: ROUTES.PROGRAM_SETTINGS_GENERAL,
        activeRoutes: [ROUTES.PROGRAM_SETTINGS_GENERAL],
      },
      {
        key: 'document-links',
        label: 'Document Links',
        route: ROUTES.PROGRAM_SETTINGS_DOCUMENT_LINKS,
        activeRoutes: [ROUTES.PROGRAM_SETTINGS_DOCUMENT_LINKS],
      },
      {
        key: 'branding-themes',
        label: 'Branding Themes',
        route: ROUTES.BRANDING_THEMES,
        activeRoutes: [
          ROUTES.BRANDING_THEMES,
          ROUTES.BRANDING_THEME_ADD,
          ROUTES.BRANDING_THEME_EDIT_PARAMS,
          ROUTES.BRANDING_THEME_VIEW_PARAMS,
        ],
      },
    ],
  },
];

export const ADVISOR_ADMIN_MENU: MainMenuItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    route: ROUTES.HOMEPAGE,
    activeRoutes: [ROUTES.HOMEPAGE],
  },
  {
    key: 'customers',
    label: 'Customers',
    route: ROUTES.CUSTOMERS,
    activeRoutes: [ROUTES.CUSTOMERS],
  },
  {
    key: 'businesses',
    label: 'Businesses',
    route: ROUTES.BUSINESSES,
    activeRoutes: [ROUTES.BUSINESSES],
  },
  {
    key: 'teammates',
    label: 'Teammates',
    route: ROUTES.TEAMMATES,
    activeRoutes: [ROUTES.TEAMMATES],
  },
  {
    key: 'bank-accounts',
    label: 'Bank Accounts',
    route: ROUTES.BANK_ACCOUNTS,
    activeRoutes: [ROUTES.BANK_ACCOUNTS],
  },
  {
    key: 'bank-account-applications',
    label: 'Bank Account Applications',
    route: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
    activeRoutes: [
      ROUTES.BANK_ACCOUNT_APPLICATIONS,
      ROUTES.BANK_ACCOUNT_APPLICATION_DETAILS,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED,
    ],
    subpages: [
      {
        key: 'draft',
        label: 'Draft',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT],
      },
      {
        key: 'awaiting-esign',
        label: 'Awaiting E-Sign',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN],
      },
      {
        key: 'submitted',
        label: 'Submitted',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED],
      },
      {
        key: 'under-review',
        label: 'Under Review',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW],
      },
      {
        key: 'completed',
        label: 'Completed',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED],
      },
    ],
  },
];

export const ADVISOR_MENU: MainMenuItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    route: ROUTES.HOMEPAGE,
    activeRoutes: [ROUTES.HOMEPAGE],
  },
  {
    key: 'customers',
    label: 'Customers',
    route: ROUTES.CUSTOMERS,
    activeRoutes: [ROUTES.CUSTOMERS],
  },
  {
    key: 'businesses',
    label: 'Businesses',
    route: ROUTES.BUSINESSES,
    activeRoutes: [ROUTES.BUSINESSES],
  },
  {
    key: 'bank-accounts',
    label: 'Bank Accounts',
    route: ROUTES.BANK_ACCOUNTS,
    activeRoutes: [ROUTES.BANK_ACCOUNTS],
  },
  {
    key: 'bank-account-applications',
    label: 'Bank Account Applications',
    route: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
    activeRoutes: [
      ROUTES.BANK_ACCOUNT_APPLICATIONS,
      ROUTES.BANK_ACCOUNT_APPLICATION_DETAILS,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW,
      ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED,
    ],
    subpages: [
      {
        key: 'draft',
        label: 'Draft',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT],
      },
      {
        key: 'awaiting-esign',
        label: 'Awaiting E-Sign',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN],
      },
      {
        key: 'submitted',
        label: 'Submitted',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED],
      },
      {
        key: 'under-review',
        label: 'Under Review',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW],
      },
      {
        key: 'completed',
        label: 'Completed',
        route: ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED,
        activeRoutes: [ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED],
      },
    ],
  },
];
